module.exports = __webpack_public_path__ + "img/p1.97825607.png";